import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useSubscriptionStatus } from 'entities/tariff/model/useSubscriptionStatus';
import { useAuthorization } from 'entities/user/hooks/useAuthorization';
import { MpTag } from 'shared/ui/MpTag';

interface Props {
	applicationId: string;
	isInHeader?: boolean;
	trialLength?: number;
	isTrialAvailable?: boolean;
}

export const SubscriptionStatusTag: FC<Props> = ({ applicationId, isInHeader, trialLength, isTrialAvailable }) => {
	const { t, i18n } = useTranslation();
	const subscriptionStatus = useSubscriptionStatus(applicationId);
	const authorization = useAuthorization();

	const tariffName =
		// eslint-disable-next-line no-nested-ternary
		applicationId !== `11EDF0CB38BDE6B8BE4756D61637848D`
			? subscriptionStatus.name ?? ``
			: i18n.language === `ru-RU`
			  ? `Открытый`
			  : `Open`;

	if (
		(!authorization && trialLength) ||
		(authorization && subscriptionStatus.status === 0 && isTrialAvailable && trialLength)
	) {
		return <MpTag color='warning'>{t(`Marketplace_Days_For_Free`, { days: trialLength })}</MpTag>;
	}

	if (authorization?.blockAppInstallation) {
		return null;
	}

	switch (subscriptionStatus.status) {
		case 0:
			return null;
		case 1:
			return (
				<MpTag color='success'>
					{isInHeader
						? `${t(`Marketplace_Subscription`)} ${tariffName}`
						: t(`Marketplace_Subscription_Active`)}
				</MpTag>
			);
		case 2:
			return <MpTag color='warning'>{t(`Marketplace_Trial`)}</MpTag>;
		case 3:
			return null;
		default:
			return null;
	}
};
